<h1 mat-dialog-title>ユーザー情報</h1>

<div mat-dialog-content>
  <form class="user-form" #userForm="ngForm">
    <mat-form-field>
      <input matInput placeholder="メールアドレス" id="email" [(ngModel)]="keySet.email" name="email" #email="ngModel"
        required>
      <mat-error *ngIf="email.errors?.required">メールアドレスの入力は必須です</mat-error>
    </mat-form-field>
    <span *ngIf="isEmailExist" id="emailExist">既に使用されているメールアドレスです</span>
    <span *ngIf="isInvalidEmail" id="emailInvalid">メールアドレスが不正です</span>
    <mat-form-field>
      <input matInput placeholder="社員番号" id="idNum" [(ngModel)]="keySet.id" name="idNum" #idNum="ngModel" required>
      <mat-error *ngIf="idNum.errors?.required">社員番号の入力は必須です</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="氏名" id="displayName" [(ngModel)]="keySet.displayName" name="displayName"
        #displayName="ngModel" required>
      <mat-error *ngIf="displayName.errors?.required">氏名の入力は必須です</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="ふりがな" id="kana" [(ngModel)]="keySet.kana" name="kana"
        #kana="ngModel" required>
      <mat-error *ngIf="kana.errors?.required">ふりがなの入力は必須です</mat-error>
    </mat-form-field>
    <span *ngIf="isInvalidKana" id="kanaInvalid">ふりがなが不正です。平仮名、ハイフン(ー)、全角スペースのみ使用出来ます。</span>
    <mat-form-field>
      <mat-select placeholder="所属部署" id="team" [(ngModel)]="teamId" name="team" #team="ngModel" required>
        <mat-option *ngFor="let t of teams" [value]="t.id">{{t.name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select placeholder="権限" id="authority" [(ngModel)]="keySet.authority" name="authority" #authority="ngModel"
        required>
        <mat-option *ngFor="let elm of authorities" [value]="elm.id">{{elm.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-select placeholder="管理権限" id="manageAuthority" [(ngModel)]="keySet.manageAuthority" name="manageAuthority"
        #manageAuthority="ngModel" required>
        <mat-option *ngFor="let elm of manageAuthorities" [value]="elm.id">{{elm.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="カードID" id="tagId" [(ngModel)]="keySet.key" name="tagId" #tagId="ngModel" required>
      <mat-error *ngIf="tagId.errors?.required">カードIDの入力は必須です</mat-error>
    </mat-form-field>
    <span *ngIf="isTagIdErr" id="idExist">未使用のカードIDを入力してください</span>
		<mat-form-field *ngIf="isNewUser">
			<input [type]="hide ? 'password' : 'text'" matInput placeholder="パスワード" id="secret" [(ngModel)]="password" name="secret"
			#secret="ngModel"
      required
      pattern="(?=.*\d)(?=.*[a-zA-Z]).{6,}"
      minlength="6">
			<mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
			<mat-error *ngIf="secret.errors?.required">パスワードの入力は必須です</mat-error>
			<mat-error *ngIf="secret.errors?.minlength">6文字以上のパスワードを指定してください</mat-error>
      <mat-error *ngIf="secret.errors?.pattern && !secret.errors?.minlength">英字・数字それぞれ1文字以上指定してください</mat-error>
    </mat-form-field>
    <section>
      <mat-label>その他付加属性</mat-label><br />
      <!-- <mat-checkbox placeholder="test" [(ngModel)]="keySet.withoutYakusya" id="withoutYakusya" name="withoutYakusya" #withoutYakusya="ngModel">就業役者打刻無し</mat-checkbox><br /> -->
      <mat-checkbox placeholder="test" [(ngModel)]="keySet.bugyoParallelOperation" id="bugyoParallelOperation" name="bugyoParallelOperation" #bugyoParallelOperation="ngModel">奉行併用</mat-checkbox>
    </section>
    <span>
      <button mat-raised-button (click)="onCancel()">キャンセル</button>

      <button (click)="request()" mat-raised-button color="primary" [disabled]="userForm.invalid">登録</button>
      <span *ngIf="isRegisterErr" id="registerErr">登録時にエラーが発生しました</span>
    </span>
  </form>
</div>
